import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioIconFn = /* @__PURE__ */ createRecipe('radio-icon', {}, [])

const radioIconVariantMap = {}

const radioIconVariantKeys = Object.keys(radioIconVariantMap)

export const radioIcon = /* @__PURE__ */ Object.assign(memo(radioIconFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioIcon',
  __getCompoundVariantCss__: radioIconFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioIconVariantKeys,
  variantMap: radioIconVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioIconVariantKeys)
  },
  getVariantProps: radioIconFn.getVariantProps,
})